<template>
    <div class="row left-content">
        <b-card
            v-if="projects"
            title="Projects"
        >
            <b-button variant="primary" @click="$router.push({name: 'admin.projects.create'})">Create new</b-button>
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Project</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="project in projects" :key="project.id">
                    <td>{{ project.value }}</td>
                    <td>{{ project.text }}</td>
                    <td></td>
                </tr>
                </tbody>
            </table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "List",
    computed: {
        projects() {
            return this.$store.state.projects;
        }
    },
    mounted() {
        this.$store.dispatch('getProjectsList');
    }
}
</script>